import { render, staticRenderFns } from "./html/PointsApplier.html?vue&type=template&id=7371952f&lang=html&external"
import script from "./js/PointsApplier.js?vue&type=script&lang=js&external"
export * from "./js/PointsApplier.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports